import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { ContactService } from '../../_services/contact.service';
import { TranslateService } from 'ngx-translate-with-country';
declare var $: any;

@Component({
  selector: 'app-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.scss']
})
export class NewsComponent  implements OnInit {

  country: string;
  language: string;
  news: any;
  id: number;
  newsbyid:any;

  constructor(
    private route: ActivatedRoute,
    private _contactService: ContactService,
    private translate: TranslateService,
  ) { }

  getNewsById(id: number, country: string, language: string): void {
    this._contactService.getNewsById(id, country, language)
      .subscribe(
        resultArray =>{
          this.newsbyid = resultArray;
        } ,

        error => console.log('Error ::' + error)
      )
  }

  ngOnInit(): void {
    setTimeout(() => {
      $(document).foundation();
    }, 230);

    this.route.params
    .subscribe(
      (params: Params) => {
        this.id = +params['id'];
        this.country = params['country'];
        this.language = params['language'];
        let homeUrl = '/' + this.country + '/' + this.language;
        this.translate.get(['CONTACTHEADING', 'SHARPHOME'])
        this.getNewsById(this.id, this.country, this.language);

      }
    )
  }

}
